import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MAX_CHARS } from 'src/app/constants/portal-user-info';

@Component({
  selector: 'app-pop-up',
  templateUrl: './pop-up.component.html',
  styleUrls: ['./pop-up.component.scss']
})
export class PopUpComponent implements OnInit {

  dialogForm: FormGroup;
  readonly char_limit = MAX_CHARS;

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<PopUpComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.dialogForm = this.fb.group({
      comment: ['', [Validators.required, Validators.maxLength(this.char_limit), Validators.pattern(/.*\S.*/)]]
    });
   }

  ngOnInit(): void {
  }

  onSubmit() {
    if (this.dialogForm.valid) {
      this.dialogRef.close(this.dialogForm.value);
    }
  }

}
